import React from 'react';
import { useField } from 'formik';
import InputMask from 'react-input-mask';
import { composeValidators, requiredValidator } from 'sd-formik-validators';
import { StyledTextField } from '../StyledTextField';
import { format, isExists, isFuture, isValid } from 'date-fns';
import { DateField, DatePicker, DesktopDatePicker } from '@mui/x-date-pickers';

export type DOBFieldProps = {
  isRequired?: boolean;
  name: string;
  label: string;
  validate?: Array<unknown>;
  helperText?: string;
  error?: string;
  style?: React.CSSProperties;
};

export function DOBField({
  isRequired = false,
  name,
  label,
  validate = [],
  helperText = '',
  error = '',
  ...props
}: DOBFieldProps) {
  const [field, meta, helper] = useField({ name });

  return (
    <DateField
      {...field}
      {...props}
      value={field?.value ? new Date(field.value) : null}
      required={isRequired}
      helperText={meta.touched && meta.error ? meta.error : helperText}
      label={label}
      onChange={e => {
        helper.setValue(isValid(e) ? e : null);
      }}
      sx={{
        '& input': {
          height: '2px',
          padding: '22px 16px 26px'
        },
        '& .MuiInputBase-root': {
          backgroundColor: 'white'
        }
      }}
    />
  );
}
